import illustration from './InboxTaskListEmptyState.svg?url';

export default function InboxTaskListEmptyState() {
	return <img src={illustration} alt="No pending tasks." />;
}
